import { MAPBOX_ETA_STATUSES } from 'constants/shipments'

export const isEtaStatus = status => MAPBOX_ETA_STATUSES.includes(status)

export const getStopsWithVisitedInfo = (stops, currentStopIndex) =>
  stops.map((stop, idx) => {
    const visited = idx < currentStopIndex || (idx === currentStopIndex && !!stop.status.arrivedAt)
    return Object.assign(stop, { visited })
  })

export const stringifyLatLng = stop => `${stop.facility.longitude},${stop.facility.latitude}`

export const getCurrentStop = (stops, currentStopIndex) => {
  if (currentStopIndex === 0 && stops[currentStopIndex].status.arrivedAt === null) {
    return stops[0]
  }
  return stops[currentStopIndex].status.arrivedAt === null
    ? stops[currentStopIndex - 1]
    : stops[currentStopIndex]
}

export const getCityState = (features = []) => {
  const { context = [] } = features[0] || {}
  const { text: city } = context.find(place => place.id.includes('place')) || {}
  const { shortCode: stateShortCode } = context.find(place => place.id.includes('region')) || {}
  return city && stateShortCode ? `${city}, ${stateShortCode.split('-')[1]}` : undefined
}

export const getCityStatePostcode = (features = []) => {
  const cityState = getCityState(features)
  const { context = [] } = features[0] || {}
  const { text: postcode } = context.find(place => place.id.includes('postcode')) || {}
  return cityState && postcode ? `${cityState}, ${postcode}` : undefined
}

export const getDistanceToFinalStop = (routes, emptyMessage = 'No') => {
  const metersToMiles = dist => `${Math.round(dist * 0.000621371)} mi`
  const finalStopDistanceMiles =
    routes.length > 0 ? metersToMiles(routes[0].distance) : emptyMessage
  return finalStopDistanceMiles
}
